// extracted by css-extract-rspack-plugin
export default {"dropdown":"yIsLL","dimensionList":"cxxLd","accordionItem":"L87n9","accordionControl":"Vjg4y","accordionControlExpanded":"oFtAC"};